// extracted by mini-css-extract-plugin
export default {"tasks":"kP-z","task":"lP-z","svg":"mP-z","text":"nP-z"};